/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_PermissionsInputs */

const en_tables_custom_pages_permissions = /** @type {(inputs: Tables_Custom_Pages_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Permissions`)
};

const de_tables_custom_pages_permissions = /** @type {(inputs: Tables_Custom_Pages_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen`)
};

/**
* | output |
* | --- |
* | "Pages Permissions" |
*
* @param {Tables_Custom_Pages_PermissionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_permissions = /** @type {((inputs?: Tables_Custom_Pages_PermissionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_PermissionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_permissions(inputs)
	return de_tables_custom_pages_permissions(inputs)
});